// Şube Rezervasyon Takvimi (Müsait Saatler) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'reservations.schedule';

export const reservationScheduleGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Rezervasyon takvimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bu sayfada şubenizin rezervasyona açık olduğu saatleri (müsaitlikleri) takvim üzerinde belirlersiniz. Müşteri rezervasyon isteklerini görmek için "Rezervasyon İsteklerini Görüntüle" düğmesini kullanın. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    toolbar: t(`${G}.regions.toolbar`, 'İstekler, link, Yeni Müsaitlik Ekle'),
    filters: t(`${G}.regions.filters`, 'Önceki / Bugün / Sonraki, Gün · Hafta · Ay'),
    table: t(`${G}.regions.table`, 'Takvim'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Görünümü seçin'),
      text: t(`${G}.s1.text`, 'Takvim ay görünümüyle açılır. Sağdaki simgelerle Gün, Hafta veya Ay görünümüne geçin; soldaki oklarla önceki / sonraki döneme gidin, ortadaki düğmeyle bugüne dönün.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Yeni müsaitlik ekleyin'),
      text: t(`${G}.s2.text`, '"Yeni Müsaitlik Ekle" düğmesine basın ya da takvimde bir güne / saate tıklayın (birden çok saati sürükleyerek de seçebilirsiniz). Açılan pencerede Müsaitlik Başlığı, Başlangıç ve Bitiş Tarihi, Başlangıç ve Bitiş Saati zorunludur; Kapasite (1–50), Renk ve Açıklama sekmesi isteğe bağlıdır. "Kaydet" ile takvime eklenir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Bitiş tarihi başlangıçtan önce olamaz; aynı gün içinde bitiş saati başlangıç saatinden sonra olmalıdır.'),
        t(`${G}.s2.tip2`, 'Ay görünümünde bir güne tıklarsanız saat 09:00–10:00 olarak, gün / hafta görünümünde tıklarsanız tıkladığınız saatten başlayarak 1 saatlik önerilir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Müsaitliği taşıyın veya uzatın'),
      text: t(`${G}.s3.text`, 'Takvimdeki bir müsaitliği sürükleyip başka güne / saate bırakırsanız yeni zamanı hemen kaydedilir. Hafta veya gün görünümünde alt kenarından çekerek süresini uzatıp kısaltabilirsiniz; bu da hemen kaydedilir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Düzenleyin veya silin'),
      text: t(`${G}.s4.text`, 'Bir müsaitliğe tıklayınca Müsaitlik Detayları açılır. "Düzenle" ile alanları değiştirip "Kaydet"e basın. "Sil" onay sorar; silinen müsaitlik geri alınamaz.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s5.title`, '5. İstekler ve rezervasyon linki'),
      text: t(`${G}.s5.text`, '"Rezervasyon İsteklerini Görüntüle" bu şubeye gelen müşteri rezervasyon isteklerini takvimde gösteren sayfayı açar; onaylama ve reddetme orada yapılır. "Rezervasyon Linkini Kopyala" şubenin rezervasyon sayfası adresini panoya kopyalar.'),
      tips: [
        t(`${G}.s5.tip1`, 'Sol üstteki geri okuyla Rezervasyonlar sayfasına dönersiniz.'),
      ],
    },
  ],
});
